import axios from 'axios';
import { API_PATHS } from 'common/utils/constants/api.constants';
import {
  CustomerPolicyInfo,
  GroupedPolicyList,
  PoliciesStatus,
  PolicyAgent,
  PolicyDetail,
  PolicyList,
  PolicyWithAgent,
} from '../types/policy.types';

class PolicyService {
  public static getPolicyDetails(policyId: string): Promise<PolicyDetail> {
    return axios.get(`${API_PATHS.POLICY_LIST}/${policyId}`).then((res) => res.data);
  }
  public static getJourneyRedirectStatus(): Promise<{ [key: string]: boolean }> {
    return axios.get(`${API_PATHS.POLICY_SUMMARY}`).then((r) => r.data);
  }
  public static getIntialCustomerPolicyData(landingProduct: string, landingFlow: string): Promise<CustomerPolicyInfo> {
    return axios
      .get(`${API_PATHS.CUSTOMER_POLICY_INITIAL_INFO}?landingProduct=${landingProduct}&landingFlow=${landingFlow}`)
      .then((r) => r.data);
  }
  public static getPoliciesStatus(pageNo: number, size: number): Promise<PoliciesStatus> {
    return axios
      .get(`${API_PATHS.POLICIES_STATUS_COUNTER}`, {
        params: {
          page: pageNo,
          size: size,
        },
      })
      .then((r) => r.data);
  }

  public static getPolicyAgent(partyId: string): Promise<PolicyAgent> {
    return axios.get(`${API_PATHS.POLICY_AGENT}/${partyId}`).then((r) => r.data);
  }

  public static getPolicyWithAgent(policyNo: string): Promise<PolicyWithAgent> {
    return axios.get(`${API_PATHS.POLICY_LIST}/${policyNo}`).then((r) => r.data);
  }

  public static getFilteredPolicies(status: string, pageNo: number, pageSize: number): Promise<PolicyList> {
    return axios
      .get(`${API_PATHS.POLICY_LIST}`, {
        params: {
          pageNo,
          pageSize,
          status,
        },
      })
      .then((r) => r.data);
  }

  public static getGroupedFilteredPolicies(status: string, pageNo: number, pageSize: number): Promise<GroupedPolicyList> {
    return axios
      .get(`${API_PATHS.GROUPED_PORTFOLIO_LIST}`, {
        params: {
          pageNo,
          pageSize,
          status,
        },
      })
      .then((r) => r.data);
  }

  public static getRedFlagPolicyStatus(): Promise<any> {
    return axios.get(`${API_PATHS.RED_FLAG_STATUS}`).then((r) => r.data);
  }
}
export default PolicyService;
